import Vuex from "vuex";
import Vue from "vue";
import { GET_INVESTMENT,GET_OPTION_SELECTED } from "./getter-types";
import { SET_INVESTMENT,SET_OPTION_SELECTED } from "./mutation-types";
import {wizardMutations} from './mutations';
import routes from '../routes/wizard';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    investment: null,
    optionSelected: null,
    wizard: {
      direction: '',
      typeApartment: '',
      occupied: '',
      floor: '',
      floorsTotal: '',
      door: '',
      size: '',
      rooms: '',
      toilets: '',
      features: [],
      state: '',
      saleState: '',
      burdened: '',
      waitingForMortgage: null,
  },
  routes: routes.children,
  exitdialog: false

  },
  getters: {
    [GET_INVESTMENT](state) {
      return state.investment;
    },
    [GET_OPTION_SELECTED](state) {
        return state.optionSelected;
      },
    getWizard(state){
        return state.wizard;
    },
    getRoutes(state){
        return state.routes;
    },
    getExitDialog(state){
        return state.exitdialog;
    }  
  },
  mutations: {
    [SET_INVESTMENT](state, payload) {
      state.investment = payload;
    },
    [SET_OPTION_SELECTED](state, payload) {
        state.optionSelected = payload;
    }
  },
  mutations: {
    ...wizardMutations
  },
  actions: {}
});
